import { Component, OnInit, OnDestroy, ContentChildren, ContentChild, ViewChild } from '@angular/core';
import { AppStateService } from '../../core/app-state.service';
import { ActivatedRoute, Router, ActivationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { ArticleCarouselComponent } from './article-carousel/article-carousel.component';
import { createContentChildren } from '@angular/compiler/src/core';

@Component({
    selector: 'articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
})
export class ArticlesComponent implements OnInit, OnDestroy {
    /** 'wc' or 'urinal' */
    public activeMode: string = 'wc';
    public articleDetailsKey: string = "";
    public isViewingDetails: boolean = false;

    @ViewChild(ArticleCarouselComponent)
    public carousel: ArticleCarouselComponent;

    private routeSubscription: Subscription;

    constructor(private appState: AppStateService,
                private router: Router,
                private route: ActivatedRoute) {}

    public ngOnInit() {
        this.routeSubscription = this.router.events.subscribe(event => {
            if (event instanceof ActivationEnd) {
                this.isViewingDetails = this.route.children.length > 0;
                // when going back from details view to the active carousel, the size (or orientation) may have changed and
                // the carousel should realign the contents just in case.
                if (!this.isViewingDetails) {
                    // hacky way to ensure that the carousel is actually visible (not hidden) when it performs its remeasuring...
                    window.setTimeout(() => {
                        this.carousel.remeasure();
                        this.carousel.resetSlides();
                    }, 1);
                }
            }
        }, console.error);

        this.isViewingDetails = this.route.children.length > 0;
    }

    public switchMode(newMode: string) {
        if (newMode !== 'wc' && newMode !== 'urinal')
            throw new Error(`Invalid mode "${newMode}" given.`);

        this.activeMode = newMode;
    }

    public ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/mobile/articles/articles.component.ts